export function truncateText({
  text,
  length = 24,
}: {
  text: string;
  length?: number;
}) {
  if (!text) return null;

  const splitText = text.split(` `);

  if (splitText.length < length) return text;

  return `${splitText.splice(0, length).join(` `)}...`;
}
